/**
 * Format time off form values into payload for API submission
 * @param {Object} values - Form values from Ant Design Form
 * @param {boolean} isPartOfDay - Whether part of day is selected
 * @returns {Object} Formatted payload
 */
export const formatTimeOffPayload = (values, isPartOfDay) => {
  const payload = {
    startDate: values.startDate?.format("MM/DD/YYYY"),
    endDate: values.endDate?.format("MM/DD/YYYY"),
    partOfDay: isPartOfDay
  }

  if (isPartOfDay) {
    payload.startTime = values.startTime?.format("hh:mm A")
    payload.endTime = values.endTime?.format("hh:mm A")
  }

  return payload
}

/**
 * Format date for display in table
 * @param {string} date - Date string
 * @returns {string} Formatted date
 */
export const formatDateDisplay = (date) => {
  if (!date) return ""
  return new Date(date).toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric"
  })
}

/**
 * Format time for display in table
 * @param {string} time - Time string
 * @returns {string} Formatted time
 */
export const formatTimeDisplay = (time) => {
  if (!time) return ""
  return time
}
